<div class="container mx-auto w-full min-h-[30px] leading-[20px] xs:leading-[30px]
            text-[11px] xs:text-[14px] flex flex-wrap lg:flex-nowrap items-center">
  @for (breadcrumb of breadcrumbsService.breadcrumbs$ | async; track $index; let last = $last) {
    @if (!last) {
      <a [routerLink]="breadcrumb.url" class="stand-breadcrumb no-underline max-w-[40%] whitespace-nowrap overflow-hidden text-ellipsis">{{breadcrumb.label}}</a>
    }
    @if (last) {
      <div class="h-5 md:h-7 flex flex-grow whitespace-nowrap overflow-hidden text-ellipsis" style="contain: strict;">{{breadcrumb.label}}</div>
    }
    @if (!last) {
      <mat-icon class="!w-5 !h-auto !md:w-6" svgIcon="core:keyboard_arrow_right"></mat-icon>
    }
  }
</div>

